import Pay from "../Steps/Pay"

let step1


// Test Step Schema
const Load_Test_Steps = () => {
    return {
        Portal: 'Test Portal',
        MainColor: "#f5924c",
        Logo: require(`../../assets/BQLogo.png`),
        Title: `<h2>Test Registration Form</h2>`,
        Description: ``,
        Model: {},
        steps: [
            // Step 1
            step1,
        ]
    }
}

export default {
    LoadSchema: async (Parameters) => {
        step1 = await Pay.LoadSchema(1)
        return Load_Test_Steps()
    },
}
